import * as React from 'react';

import styles from './ObjectsLayout.css';
import { trackObjectPriceLinkClick } from '../../../tracking';

interface IContentWrapperLinkProps {
  url?: string;
}

export const ContentWrapperLink: React.FC<React.PropsWithChildren<IContentWrapperLinkProps>> = ({ url, children }) => {
  return url ? (
    <a href={url} className={styles['link']} onClick={trackObjectPriceLinkClick}>
      {children}
    </a>
  ) : (
    (children as React.ReactElement)
  );
};
